module.exports = __webpack_public_path__ + "ev-search.svg?35b871933f54661f6991969c855e2aac";